export const DEFAULT_LANGUAGE = 'en'

export const DEFAULT_LANGUAGE_OBJECT = {
  key: 'en',
  name: 'English',
  englishName: 'English',
}

export const SUPPORTED_LANGUAGES = {
  AUTO: 'auto',
  ENGLISH: 'en',
  SPANISH: 'es',
  PORTUGUESE: 'pt',
  GERMAN: 'de',
  KOREAN: 'ko',
  ARABIC: 'ar',
  FRENCH: 'fr',
  HINDI: 'hi',
  INDONESIAN: 'id',
  POLISH: 'pl',
  TAGALOG: 'tl',
  THAI: 'th',
  TURKISH: 'tr',
  'ZH-HANS': 'zh-Hans',
  'ZH-HANT': 'zh-Hant',
  ITALIAN: 'it',
  RUSSIAN: 'ru',
  JAPANESE: 'ja',
  DUTCH: 'nl',
}

export const getLanguageOriginalName = (lang: string): string => {
  switch (lang) {
    case 'auto':
      return 'Auto'
    case 'en':
      return 'English'
    case 'es':
      return 'Español'
    case 'pt':
      return 'Português'
    case 'ko':
      return '한국어'
    case 'ar':
      return 'اَلْعَرَبِيَّةُ'
    case 'de':
      return 'Deutsch'
    case 'fr':
      return 'Français'
    case 'hi':
      return 'हिंदी'
    case 'id':
      return 'Bahasa Indonesia'
    case 'pl':
      return 'Polski'
    case 'tl':
      return 'Wikang Tagalog'
    case 'th':
      return 'ภาษาไทย'
    case 'tr':
      return 'Türkçe'
    case 'zh-Hans':
      return '简体中文'
    case 'zh-Hant':
      return '繁體中文'
    case 'it':
      return 'Italiano'
    case 'ru':
      return 'Русский'
    case 'ja':
      return '日本語'
    case 'nl':
      return 'Nederlands'
    default:
      return 'en'
  }
}

// Get language name in English
export const getEnglishLanguageName = (lang: string): string => {
  switch (lang) {
    case 'auto':
      return 'Auto'
    case 'en':
      return 'English'
    case 'es':
      return 'Spanish'
    case 'pt':
      return 'Portuguese'
    case 'ko':
      return 'Korean'
    case 'ar':
      return 'Arabic'
    case 'de':
      return 'German'
    case 'fr':
      return 'French'
    case 'hi':
      return 'Hindi'
    case 'id':
      return 'Indonesian'
    case 'pl':
      return 'Polish'
    case 'tl':
      return 'Tagalog'
    case 'th':
      return 'Thai'
    case 'tr':
      return 'Turkish'
    case 'zh-Hans':
      return 'Chinese Simplified (Hans)'
    case 'zh-Hant':
      return 'Chinese Traditional (Hant)'
    case 'it':
      return 'Italian'
    case 'ru':
      return 'Russian'
    case 'ja':
      return 'Japanese'
    case 'nl':
      return 'Dutch'
    case 'xh':
      return 'UwUified'
    default:
      return ''
  }
}

export const getLanguagesData = () =>
  Object.values(SUPPORTED_LANGUAGES).map((key) => ({
    key,
    name: getLanguageOriginalName(key),
    englishName: getEnglishLanguageName(key),
  }))
